export enum TuffexProductCollectionWorkspaceCapabilityUdoTemplateKey {
    collection = "ab7676c6-8350-4bb8-b86b-6b1de64b45c6",
    membership = "4b5afd65-cbf5-4a9a-ad1c-7c78eea2ade0",
}
